import type { ItemDTO } from "@barkup/shared";

/**
 * Material Symbols glyph for a FILE item, picked from its mimeType/filename so a
 * PDF, an Excel sheet and a Word doc are told apart at a glance. Only the glyph
 * varies — never the tile colour: DESIGN.md's "Quiet Archive" palette stays
 * intact (all files keep the primary-container tone). Consulted only for
 * kind === "FILE"; other kinds use the caller's kind map.
 */
export function fileIconFor(item: Pick<ItemDTO, "filename" | "mimeType">): string {
  const mime = (item.mimeType ?? "").toLowerCase();
  const ext = (item.filename ?? "").toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] ?? "";

  const matches = (mimeParts: string[], exts: string[]) =>
    mimeParts.some((m) => mime.includes(m)) || exts.includes(ext);

  if (matches(["pdf"], ["pdf"])) return "picture_as_pdf";
  if (matches(["spreadsheet", "excel", "ms-excel", "csv"], ["xls", "xlsx", "csv", "ods", "numbers"]))
    return "table_chart";
  if (matches(["presentation", "powerpoint", "ms-powerpoint"], ["ppt", "pptx", "odp", "key"]))
    return "co_present";
  if (matches(["word", "msword", "opendocument.text", "officedocument.wordprocessing", "rtf"], ["doc", "docx", "odt", "rtf"]))
    return "description";
  if (matches(["zip", "compressed", "x-tar", "x-rar", "x-7z", "gzip"], ["zip", "rar", "7z", "tar", "gz"]))
    return "folder_zip";
  if (mime.startsWith("audio/")) return "audio_file";
  if (mime.startsWith("text/") || ext === "txt") return "description";
  return "draft";
}
